import React from "react";
import Box from "@mui/material/Box";
import DashboardSafeLeavesTrend from "../web/widgets/DashboardSafeLeavesTrend";

export default function MobileDashboardSafeLeavesTrend() {
    return (
        <Box sx={{
            "& .MuiCard-root": {
                borderRadius: "16px",
                boxShadow: "0 8px 24px rgba(15, 23, 42, 0.10)",
            }
        }}>
            <DashboardSafeLeavesTrend />
        </Box>
    );
}
